(function() {
    'use strict';
    
a3_cabin_reports.factory('CCMSFactory', CCMSFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CCMSFactory
    * @description 
    *   Manage CCMS.
    * @ngInject
    */
function CCMSFactory(GenericService) {
       
        /**
         * Initialiaze CCMS object 
         * @memberof CCMSFactory
         */
		function CCMS() {
			this.Aircraft = null;
			this.Positions = new Array();
            this.CrewComments = new Array();
		}
			
		var objType = 'ccms';
		var objCallback = CCMS;  

		var service = {
			getCCMSFromStorage : getCCMSFromStorage,
			setCCMSToStorage : setCCMSToStorage  
		}

        /**
         * Get all the CCMS objects
         * @memberof CCMSFactory
         * @returns {array} CCMS
         */
		function getCCMSFromStorage() {
			return GenericService.list(objType,objCallback);
		}

        /**
         * Set all the CCMS
         * @memberof CCMSFactory
         * @param {array} objects A list of CCMS.
         */
		function setCCMSToStorage(ccms) {
			GenericService.saveAll(ccms,objType,objCallback);
		}

		return service;
	}

})();